(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 991;
  var root = document.querySelector('[data-mld-mobile-menu]');
  var trigger = document.getElementById('open-button');

  if (!root || !trigger) {
    return;
  }

  var panel = root.querySelector('.mld-mobile-menu__panel');
  var closeControls = root.querySelectorAll('[data-mld-mobile-menu-close]');
  var focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var isOpen = false;
  var isAnimating = false;
  var lastFocusedElement = null;
  var scrollPosition = 0;
  var animationFrameOne = null;
  var animationFrameTwo = null;
  var closeTimer = null;
  var panelTransitionDuration = 300; /* > --mld-dur-base (salida, 200 ms) */

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getFocusableElements() {
    return Array.prototype.slice.call(root.querySelectorAll(focusableSelectors)).filter(function (element) {
      /* el fondo (botón con tabindex="-1") no es una parada de Tab: solo se cierra con clic */
      return !element.hasAttribute('hidden') && element.offsetParent !== null && element.getAttribute('tabindex') !== '-1';
    });
  }

  function syncTriggerState(expanded) {
    trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function lockScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.classList.add('mld-mobile-menu-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.classList.remove('mld-mobile-menu-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollPosition);
  }

  function hideLegacyDrawer() {
    document.body.classList.remove('show-menu');
    var legacyDrawer = document.querySelector('.menu-wrap');
    if (legacyDrawer) {
      legacyDrawer.setAttribute('aria-hidden', 'true');
      /* El menú lateral viejo ya no se abre (lo reemplaza .mld-mobile-menu), pero sus links
         seguían en el orden de tabulación: al tabular, el navegador desplazaba #content-wrap
         para mostrarlos y el layout se corría. inert lo saca del foco y de los lectores;
         el CSS (moldarte-mobile-menu.css) además lo deja en display:none. */
      legacyDrawer.setAttribute('inert', '');
      legacyDrawer.inert = true;
    }
  }

  function clearAnimationFrames() {
    if (animationFrameOne) {
      window.cancelAnimationFrame(animationFrameOne);
      animationFrameOne = null;
    }

    if (animationFrameTwo) {
      window.cancelAnimationFrame(animationFrameTwo);
      animationFrameTwo = null;
    }

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function openMenu() {
    if (isOpen || isAnimating || !isMobileViewport()) {
      return;
    }

    clearAnimationFrames();
    lastFocusedElement = document.activeElement;
    isOpen = true;
    isAnimating = true;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    root.classList.remove('is-closing', 'is-active');
    root.classList.add('is-visible');
    syncTriggerState(true);
    lockScroll();
    hideLegacyDrawer();

    animationFrameOne = window.requestAnimationFrame(function () {
      animationFrameTwo = window.requestAnimationFrame(function () {
        root.classList.add('is-active');
        isAnimating = false;

        if (panel) {
          panel.focus();
        }
      });
    });
  }

  function closeMenu(options) {
    if (!isOpen && !isAnimating) {
      return;
    }

    var settings = options || {};
    clearAnimationFrames();
    isOpen = false;
    isAnimating = true;
    root.classList.remove('is-active');
    root.classList.add('is-closing');
    root.setAttribute('aria-hidden', 'true');
    syncTriggerState(false);
    unlockScroll();
    hideLegacyDrawer();

    closeTimer = window.setTimeout(function () {
      if (!isOpen) {
        root.hidden = true;
        root.classList.remove('is-visible', 'is-closing');
      }
      isAnimating = false;
      closeTimer = null;
    }, panelTransitionDuration);

    if (settings.returnFocus !== false && lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      window.requestAnimationFrame(function () {
        lastFocusedElement.focus();
      });
    }
  }

  function onTriggerClick(event) {
    if (!isMobileViewport()) {
      syncTriggerState(false);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  function onDocumentKeydown(event) {
    if (!isOpen) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeMenu();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    var focusable = getFocusableElements();
    if (!focusable.length) {
      event.preventDefault();
      if (panel) {
        panel.focus();
      }
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function onDocumentClick(event) {
    if (!isOpen) {
      return;
    }

    if (panel && panel.contains(event.target)) {
      return;
    }

    if (event.target === trigger || trigger.contains(event.target)) {
      return;
    }

    if (root.contains(event.target)) {
      closeMenu({ returnFocus: false });
    }
  }

  function onResize() {
    hideLegacyDrawer();

    if (!isMobileViewport() && (isOpen || isAnimating)) {
      closeMenu({ returnFocus: false });
    }
  }

  trigger.setAttribute('aria-haspopup', 'dialog');
  trigger.setAttribute('aria-controls', 'mld-mobile-menu-panel');
  trigger.setAttribute('aria-expanded', 'false');

  if (window.jQuery && window.jQuery.fn) {
    window.jQuery(trigger).off('click');
  }

  trigger.addEventListener('click', onTriggerClick, true);

  Array.prototype.forEach.call(closeControls, function (control) {
    control.addEventListener('click', function (event) {
      event.preventDefault();
      closeMenu();
    });
  });

  root.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (link) {
      closeMenu({ returnFocus: false });
    }
  });

  document.addEventListener('keydown', onDocumentKeydown);
  document.addEventListener('click', onDocumentClick);
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize);

  hideLegacyDrawer();
})();
